<template>
  <div id="buyerCartPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-cart-shopping fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">سبد سفارشات من</span>
                </div>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="onlineOrdersTab ? 'profile-active-tab':''" class="pointer" @click="showOnlineOrdersTab">سفارشات از فروشگاه آنلاین</span>
              </div>
              <div class="col-6 text-center font-weight-bold">
                <span :class="offlineOrdersTab ? 'profile-active-tab':''" class="pointer" @click="showOfflineOrdersTab">سفارشات از فروشگاه آفلاین</span>
              </div>

            </div>
            <div v-if="onlineOrdersTab" class="row">
              <div v-if="onlineOrders.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز سفارشی ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12">
                <div class="col ">
                  <v-text-field
                      append-icon="far fa-magnifying-glass"
                      class="rounded-lg"
                      dense
                      flat
                      hide-details
                      clearable
                      v-model="searchOnlineKeyword"
                      placeholder=" کد پیگیری"
                      @keyup="searchOnline"
                      @click:clear="removeSearchOnline"
                      solo>
                  </v-text-field>
                </div>
                <div v-if="!hasOnlineResult" class="col-12 text-center">
                  نتیجه ای یافت نشد
                </div>
                <div v-for="(item,i) in onlineOrders" :key="i" class="col-12">
                  <div class="rounded-lg bg-white row p-1 py-2">
                    <div class="col-6 ">{{ i + 1 }}</div>
                    <div class="col-6 text-left">{{ $TypeInvoiceStatus(item.TypeInvoiceStatus) }}</div>
                    <div class="col-6 py-1">کد پیگیری</div>
                    <div class="col-6 py-1 text-left">{{ item.TrackingCode }}</div>
                    <div class="col-6 py-1">تاریخ سفارش</div>
                    <div class="col-6 py-1 text-left">{{ $convertDate(item.ModifiedDate) }}</div>
                    <div class="col-6 py-1">روش پرداخت</div>
                    <div class="col-6 py-1 text-left">{{ $TypePayment(item.TypePayment) }}</div>
                    <div class="col-6">نام فروشگاه</div>
                    <div class="col-6 text-left">{{ item.VendorName }}</div>
                    <div class="col-12 py-1 pointer" @click="seeData(item.VendorInvoiceID)"><i
                        class="fa-regular fa-store fa-lg ml-2"></i> مشاهده اطلاعات
                      فروشگاه
                    </div>
                    <div class="col-12 py-1 pointer" @click="seeFactor(item.VendorInvoiceID)"><i
                        class="fa-regular fa-file-lines fa-lg ml-2 mr-1"></i> مشاهده
                      فاکتور خرید
                    </div>
                    <div class="col-12 py-1 pointer" @click="seeAddress(item.VendorInvoiceID)"><i
                        class="fa-regular fa-circle-info fa-lg ml-2"></i> مشاهده آدرس
                      تحویل
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="offlineOrdersTab" class="row">

              <div v-if="offlineOrders.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  هنوز سفارشی ثبت نشده است
                </div>

              </div>
              <div v-else class="col-12">
                <div class="col ">
                  <v-text-field
                      append-icon="far fa-magnifying-glass"
                      class="rounded-lg"
                      dense
                      clearable
                      flat
                      v-model="searchOfflineKeyword"
                      hide-details
                      placeholder=" کد پیگیری"
                      @keyup="searchOffline"
                      @click:clear="removeSearchOffline"
                      solo>
                  </v-text-field>
                </div>
                <div v-if="!hasOfflineResult" class="col-12 text-center">
                  نتیجه ای یافت نشد
                </div>
                <div v-else v-for="(item,i) in offlineOrders" :key="i" class="col-12">
                  <div class="rounded-lg bg-white row p-1 py-2">
                    <div class="col-6 ">{{ i + 1 }}</div>
                    <div class="col-6  text-left">{{ $TypeInvoiceStatus(item.TypeInvoiceStatus) }}</div>
                    <div class="col-6 py-1">کد پیگیری</div>
                    <div class="col-6 py-1 text-left">{{ item.TrackingCode }}</div>
                    <div class="col-6 py-1">تاریخ سفارش</div>
                    <div class="col-6 py-1 text-left">{{ $convertDate(item.ModifiedDate) }}</div>
                    <div class="col-6 py-1">روش پرداخت</div>
                    <div class="col-6 py-1 text-left">{{ $TypePayment(item.TypePayment) }}</div>
                    <div class="col-6">نام فروشگاه</div>
                    <div class="col-6 text-left">{{ item.VendorName }}</div>
                    <div class="col-12 py-1 pointer" @click="seeOfflineSender(item.VendorInvoiceID)"><i
                        class="fa-regular fa-store fa-lg ml-2"></i> مشاهده اطلاعات فروشگاه
                    </div>
                    <div class="col-12 py-1 pointer" @click="seeOfflineFactor(item.VendorInvoiceID)"><i
                        class="fa-regular fa-file-lines fa-lg ml-2 mr-1"></i> مشاهده فاکتور خرید
                    </div>
                    <div class="col-12 py-1 pointer" @click="seeOfflineAddress(item.VendorInvoiceID)"><i
                        class="fa-regular fa-circle-info fa-lg ml-2"></i> مشاهده آدرس تحویل و تحویل گیرنده
                    </div>
                    <div v-if="item.FileUrl !== null" class="col-12 py-1 pointer" @click="openFactor(item.FileUrl)"><i
                        class="fa-regular fa-cloud-arrow-up fa-lg ml-2"></i>مشاهده رسید واریزی
                    </div>
                    <div v-else class="col-12 py-1 pointer" @click="openUploadModal(item.VendorInvoiceID)"><i
                        class="fa-regular fa-cloud-arrow-up fa-lg ml-2"></i>آپلود رسید واریزی
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
    <v-bottom-sheet v-model="openBottomSheet" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            {{ bottomSheetTitle }}
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheet = !openBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12">
            <div v-html="bottomSheetText">

            </div>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="uploadBankReceiptBottomSheet" class="bottom-sheet" width="600">
      <v-sheet
          class="rounded-t-xl">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            آپلود رسید واریزی
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon

                @click="uploadBankReceiptBottomSheet = !uploadBankReceiptBottomSheet">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-12 text-center">
            <v-btn
                block
                class="pb-1 secondary-gradient-btn"
                color="primary" depressed
                @click="$refs.inputUpload.click()">
              آپلود فیش واریزی
            </v-btn>
            <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                   name="ImageFileUrl" type="file"
                   @change="attachmentSelected">
            <img id="selectedImageElement"
                 :src="selectedImage"
                 class="img-fluid mt-3 upload-photo-cart"/>
            <div class="text-center">
              <v-btn :disabled="selectedImage === ''" class="mt-4" color="primary"
                     depressed @click="uploadReceipt">
                ثبت فیش
              </v-btn>
            </div>
          </div>
        </div>

      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="openBottomSheetFactorDetail" class="bottom-sheet" scrollable>
      <v-sheet
          class="rounded-t-xl rounded-t-xl overflow-y-auto overflow-x-hidden">
        <div class="row no-gutters align-items-center">
          <div class="col pr-5 py-2 toggle-filter-btn">
            فاکتور خرید
          </div>
          <div class="col text-left pl-4">
            <v-btn
                icon
                @click="openBottomSheetFactorDetail = !openBottomSheetFactorDetail">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
            </v-btn>
          </div>
        </div>
        <div class="my-3 text-center" v-html="factorTitle"></div>
        <div style="overflow: auto">
          <v-data-table
              :headers="headers"
              :items="detailOrder"
              :items-per-page="5"
              :light="true"
              :mobile-breakpoint="680"
              class="data-table"
              fixed-header>

            <template v-slot:[`item.FileUrl`]="{ item }">
              <div class="p-2">
                <v-img :src="$replaceHttps(item.FileUrl)" height="150"
                       width="150">
                </v-img>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "BuyerCart",
  metaInfo: {
    title: 'ایوان خانه- سبد سفارشات من',
  },
  components: {BackBar},
  data: () => ({
    searchOfflineKeyword:'',
    searchOnlineKeyword:'',
    hasOfflineResult:true,
    hasOnlineResult:true,
    openBottomSheetFactorDetail: false,
    uploadBankReceiptBottomSheet: false,
    openBottomSheet: false,
    offlineOrdersTab: false,
    onlineOrdersTab: true,
    detailOrder: [],
    onlineOrders: [],
    offlineOrders: [],
    isDataLoaded: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: null,
    bottomSheetTitle: null,
    bottomSheetText: null,
    factorTitle: null,
    headers: [
      {text: 'محصول', value: 'Name'},
      {text: 'تخفیف', value: 'Discount'},
      {text: 'عکس', value: 'FileUrl', sortable: false,},
      {text: 'تعداد سفارش', value: 'NumberNeed'},
      {text: ' مجموع ردیف', value: 'TotalRow'},
      {text: 'فروشنده', value: 'VendorName'},
    ],
    selectedImage: '',
    vendorID: null,
    allOffline:[],
    allOnline:[],
  }),
  mounted() {
    this.getOnlineOrders()
    this.getOfflineOrders()
  },
  methods: {
    showOnlineOrdersTab() {
      this.onlineOrdersTab = true;
      this.offlineOrdersTab = false
      if (this.onlineOrdersTab.length <= 0) {
        this.getOnlineOrders()
      }
    },
    showOfflineOrdersTab() {
      this.onlineOrdersTab = false;
      this.offlineOrdersTab = true;
      if (this.offlineOrders.length <= 0) {
        this.getOfflineOrders()
      }
    },
    getOnlineOrders() {
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportOnline/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.onlineOrders = json
            this.allOnline = json
            this.showLoaderDialog=false
          })
          .catch(error => console.log('error', error));

    },
    getOfflineOrders() {
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportSpecial/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.offlineOrders = json
            this.allOffline = json
            this.showLoaderDialog= false
          })
          .catch(error => console.log('error', error));


    },
    seeOfflineSender(id) {
      this.openBottomSheet = true
      this.bottomSheetTitle = 'اطلاعات فروشگاه'
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportSpecial/_ShowVendorInfoInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.bottomSheetText = result
          })
          .catch(error => console.log('error', error));
    },
    seeOfflineFactor(id) {
      this.openBottomSheetFactorDetail = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportSpecial/_DetailsInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.factorTitle = json.Factor
            this.detailOrder = json.list


          })
          .catch(error => console.log('error', error));
    },
    seeOfflineAddress(id) {
      this.openBottomSheet = true
      this.bottomSheetTitle = 'آدرس'
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportSpecial/_ShowAddress", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.bottomSheetText = result

          })
          .catch(error => console.log('error', error));
    },
    openUploadModal(id) {
      this.vendorID = id
      this.uploadBankReceiptBottomSheet = true
    },
    openFactor(link) {
      this.$openLink(link)
    },
    seeAddress(id) {
      this.openBottomSheet = true
      this.bottomSheetTitle = ' مشاهده آدرس'
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportOnline/_ShowAddress", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.bottomSheetText = result
          })
          .catch(error => console.log('error', error));
    },
    seeFactor(id) {
      this.openBottomSheetFactorDetail = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportOnline/_DetailsInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.factorTitle = json.Factor
            this.detailOrder = json.list


          })
          .catch(error => console.log('error', error));
    },
    seeData(id) {
      this.openBottomSheet = true
      this.bottomSheetTitle = 'اطلاعات فروشگاه'
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorInvoiceID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportOnline/_ShowVendorInfoInvoice", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.bottomSheetText = result
          })
          .catch(error => console.log('error', error));
    },
    attachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        let rawImg;
        fr.onloadend = () => {
          rawImg = fr.result;
          this.selectedImageFilePath = rawImg
        }
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImage = fr.result
          // this is an image file that can be sent to server...
        })
      } else {
        this.selectedImage = null;
        this.selectedImageFilePath = null;
      }


    },
    uploadReceipt() {
      this.uploadBankReceiptBottomSheet = false
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("Base64Image", this.selectedImageFilePath);
      formdata.append("VendorInvoiceID", this.vendorID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/InvoiceReportSpecial/UploadReceiptPurchaseFileUrl", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.getOfflineOrders()
          })
          .catch(error => console.log('error', error));
    },
    removeSearchOffline(){
      this.offlineOrders = this.allOffline
      this.hasOfflineResult = true
    },
    searchOffline(){
      let result = this.offlineOrders.filter(x => x.TrackingCode.includes(this.searchOfflineKeyword));
      if (this.searchOfflineKeyword === '') {
        this.offlineOrders = this.allOffline
        this.hasOfflineResult = true
      } else {
        if (result.length === 0) {
          this.hasOfflineResult = false
        } else {
          this.hasOfflineResult = true
          this.offlineOrders = result
        }
      }
    },
    removeSearchOnline(){
      this.onlineOrders = this.allOnline
      this.hasOnlineResult = true
    },
    searchOnline(){
      let result = this.onlineOrders.filter(x => x.TrackingCode.includes(this.searchOnlineKeyword));
      if (this.searchOnlineKeyword === '') {
        this.onlineOrders = this.allOnline
        this.hasOnlineResult = true
      } else {
        if (result.length === 0) {
          this.hasOnlineResult = false
        } else {
          this.hasOnlineResult = true
          this.onlineOrders = result
        }
      }
    }


  }
}
</script>

<style scoped>

</style>